export interface PriceDynamicsData {
  avgTransactionPrice: number
  avgTransactionPriceChange: number
  medianPricePerM2: number
  medianPricePerM2Change: number
  totalMarketVolume: number
  totalMarketVolumeChange: number
  priceVelocityIndex: number
  priceVelocityIndexChange: number
  priceDistribution: Array<{ range: string; count: number }>
  pricePerM2ByType: Array<{ type: string; price: number }>
  sparklineData: number[]
  yearlyMarketVolume?: Array<{ year: string; volume: number }>
}

export interface PriceDynamicsChartLabels {
  avgTransactionPrice?: string
  totalMarketVolume?: string
  priceVelocityIndex?: string
  yoy?: string
  mom?: string
  noData?: string
  priceDistribution?: string
  priceByPropertyType?: string
  yearlyMarketVolume?: string
}

export const DEFAULT_PRICE_DYNAMICS_CHART_LABELS: PriceDynamicsChartLabels = {
  avgTransactionPrice: 'Average Transaction Price',
  totalMarketVolume: 'Total Market Volume',
  priceVelocityIndex: 'Price Velocity Index',
  yoy: 'YoY',
  mom: 'MoM',
  noData: 'No data available',
  priceDistribution: 'Price Distribution',
  priceByPropertyType: 'Price by Property Type',
  yearlyMarketVolume: 'Yearly Market Volume',
}

export interface PriceDynamicsChartProps {
  data: PriceDynamicsData | null
  loading?: boolean
  error?: string | null
  labels?: Partial<PriceDynamicsChartLabels>
}
